import { debounce } from 'lodash';
import { Box, Stack, TextField, Toolbar as MuiToolbar, FormControl, InputLabel, Button } from '@mui/material';
import DatePicker from 'react-multi-date-picker';
import persian_fa from 'react-date-object/locales/persian_fa';
import persian from 'react-date-object/calendars/persian';
import { useRef, useState } from 'react';

export const Toolbar = ({ action, onDateChange = () => undefined }) => {
  const { query, setQuery, name, CTA, AT, filters, handleChange, filterTitle = 'وضعیت' } = action;
  const datePickerRef = useRef();
  const [datePickerValue, setDatePickerValue] = useState();

  return (
    <MuiToolbar sx={{ my: 1 }}>
      <Stack display="flex" flexDirection="row" sx={{ width: '100%' }}>
        {[
          'tags',
          'sliders',
          'banners',
          'features',
          'edit-reqs',
          'onboard_webinar',
          'recommendation_tags',
          'recommendation_question',
          'recommendation_conflict',
          'recommendation_relation',
        ].includes(name) && (
          <TextField
            onChange={debounce((e) => setQuery({ ...query, keyword: e.target.value }), 1300)}
            placeholder="جستجو"
            sx={{ mx: 1, width: 300 }}
            autoComplete="off"
          />
        )}
        {['templates', 'new_templates', 'all_webinar', 'new_webinar'].includes(name) && (
          <>
            <TextField
              value={query.keyword}
              onChange={(e) => handleChange(e.target.value)}
              placeholder="جستجو"
              sx={{ mx: 1, width: 300 }}
              autoComplete="off"
            />
            <DatePicker
              locale={persian_fa}
              calendar={persian}
              range
              ref={datePickerRef}
              inputClass="date-picker-input"
              rangeHover
              editable={false}
              dateSeparator=" تا "
              value={datePickerValue}
              onChange={(e) => setDatePickerValue(e)}
              numberOfMonths={1}
              onClose={() => {
                onDateChange(datePickerValue);
              }}
              render={<TextField label="تاریخ" sx={{ mx: 2 }} />}
            >
              <Button
                variant="contained"
                style={{ width: '50%', borderRadius: '0px' }}
                onClick={() => {
                  onDateChange(datePickerValue);
                  datePickerRef.current.closeCalendar();
                }}
              >
                تایید
              </Button>
              <Button
                variant="outlined"
                style={{ width: '50%', borderRadius: '0px' }}
                onClick={() => {
                  onDateChange(null);
                  setDatePickerValue(null);
                }}
              >
                حذف
              </Button>
            </DatePicker>
          </>
        )}
        {[
          'banners',
          'templates',
          'all_webinar',
          'recommendation_tags',
          'recommendation_question',
          'recommendation_conflict',
        ].includes(name) && (
          <FormControl sx={{ width: 300 }}>
            <InputLabel>{filterTitle}</InputLabel>
            {filters}
          </FormControl>
        )}

        {/* {['templates', 'edit-reqs'].includes(name) && (
          <FormControl sx={{ width: 300, mx: 1 }}>
            <InputLabel>نوع سایت</InputLabel>
            {customFilters}
          </FormControl>
        )} */}

        <Box sx={{ flexGrow: 1 }} />

        {typeof AT !== 'undefined' ? (
          Array.isArray(AT) ? (
            AT.map((item, index) => (
              <Button key={index} sx={{ marginLeft: 1 }} onClick={item.action} variant={item.variant || 'contained'}>
                {item.title}
              </Button>
            ))
          ) : (
            <Button onClick={CTA} variant="contained">
              {AT}
            </Button>
          )
        ) : null}
      </Stack>
    </MuiToolbar>
  );
};
